<script>
import { vueVimeoPlayer } from 'vue-vimeo-player';

export default {
    name: 'Video',
    components: {
        vueVimeoPlayer,
    },
    props: {
        component: {
            type: Object,
            default: () => {},
        },
        isActive: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            width: undefined,
            height: undefined,
            playerReady: false,
        };
    },
    computed: {
        playerOptions() {
            return {
                muted: true,
                background: true,
                autoplay: this.isActive,
                loop: true,
                controls: false,
                playsinline: true,
            };
        },
    },
    watch: {
        isActive(active) {
            if (!this.playerReady) return;

            if (active) {
                this.play();
            } else {
                this.pause();
            }
        },
    },
    mounted() {
        if (this.$refs.video !== undefined) {
            this.width = this.$refs.video.clientWidth;
            this.height = this.$refs.video.clientHeight;
        }
    },
    methods: {
        onReady() {
            this.playerReady = true;
            // If slide is active when player becomes ready, ensure it's playing
            if (this.isActive) {
                this.play();
            }
        },
        play() {
            const { player } = this.$refs;
            if (player) {
                player.play();
            }
        },
        pause() {
            const { player } = this.$refs;
            if (player) {
                player.pause();
            }
        },
    },
};
</script>

<template>
    <div
        ref="video"
        class="w-full h-full"
    >
        <client-only>
            <vimeo-player
                ref="player"
                class="object-cover w-full h-full"
                :video-id="component.vimeo_id"
                :autoplay="isActive"
                :player-width="width"
                :player-height="height"
                :loop="true"
                :options="playerOptions"
                @ready="onReady"
            />
        </client-only>
    </div>
</template>

<style scoped lang="scss">

</style>
